// React, Next
import { ReactElement, useContext, useEffect, useState } from 'react'

// MUI
import Box from '@mui/material/Box'

// Context
import { GlobalContext } from 'context/GlobalContextProvider'

// Style
import breakpoints from '@/assets/theme/breakpoints'

type Props = {
  content: ReactElement
  background?: string
  paddingTop?: string
  paddingBottom?: string
  marginTop?: string
  marginBottom?: string
  justifyContent?: 'center' | 'left' | 'right'
}

export default function Section(props: Props) {
  const { screenDimensions } = useContext(GlobalContext)

  const [sidePadding, setSidePadding] = useState('0rem')

  const getSidePadding = () => {
    const w = screenDimensions.width
    if (w > breakpoints.desktopLarge) return '15rem'
    if (w > breakpoints.desktopMid) return '10rem'
    if (w > breakpoints.desktopSmall) return '4rem'
    if (w > breakpoints.desktopToMobile) return '4rem'
    if (w > breakpoints.mobileLarge) return '2rem'
    if (w > breakpoints.mobileMid) return '1.5rem'
    if (w > breakpoints.mobileSmall) return '1rem'
    if (w > breakpoints.mobileSmaller) return '0.75rem'
    return '0.5rem'
  }

  useEffect(() => {
    setSidePadding(getSidePadding())
  }, [screenDimensions.width])

  // *** MAIN RENDER ***
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        justifyContent: props.justifyContent ?? 'center',
        background: props.background ?? '#fff',
        paddingTop: props.paddingTop ?? 0,
        paddingBottom: props.paddingBottom ?? 0,
        paddingLeft: sidePadding,
        paddingRight: sidePadding,
        marginTop: props.marginTop ?? 0,
        marginBottom: props.marginBottom ?? 0
      }}
    >
      {props.content}
    </Box>
  )
}
